import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteDockCompanyActions as Actions,
  DeleteDockCompanyRequestAction as RequestAction,
} from 'store/ducks/dockCompanies';

export function* deleteDockCompanyRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `dock-companies/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Cliente desvinculado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
